<template>
  <a-modal
    width="702px"
    :title="title"
    :mask-closable="false"
    :visible="showLoginListVisible"
    :userId="userId"
    @cancel="onCancelShowLoginList"
    :footer="null"
    :destroyOnClose="true"
    class="show-login-list"
  >
    <a-table
      :columns="showLoginListColumns"
      :data-source="data"
      :loading="loading"
      :row-key="(record) => record.id"
      :pagination="{
        pageSize,
        total,
        current,
        showTotal: (total) => `共${total}条`,
      }"
      @change="changePage"
    >
    </a-table>
  </a-modal>
</template>

<script>
import { showLoginListColumns } from "../data/index";
export default {
  props: ["userId", "userName", "userGrade", "showLoginListVisible"],
  data() {
    return {
      showLoginListColumns,
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      data: [],
      title: "",
    };
  },
  watch: {
    showLoginListVisible(val) {
      if (this.showLoginListVisible) {
        this.title = this.userName + "(班级: " + this.userGrade + ")  登录日志";
        this.showList();
      }
    },
  },
  methods: {
    onCancelShowLoginList() {
      this.data = [];
      this.total = 0;
      this.current = 1;
      this.title = "";
      this.$parent.hiddenModelType("login");
    },
    async showList() {
      this.loading = true;
      let params = {
        page: this.current,
        pageSize: this.pageSize,
        userId: this.userId,
      };
      let result = await this.$http.post("/promoter/showLoginList", params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            login_time: item.login_time,
            login_ip: item.login_ip,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      } else {
        this.loading = false;
        this.$message.error(result.data.msg);
      }
    },
    // 分页
    changePage(pagination) {
      this.current = pagination.current;
      this.showList({
        page: this.current,
        pageSize: this.pageSize,
        userId: this.userId,
      });
    },
  },
};
</script>

<style>
.show-login-list .ant-modal-content .ant-modal-header {
  padding: 16px 24px;
  color: rgba(0, 0, 0, 0.65);
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 4px 4px 0 0;
  height: auto;
}
.show-login-list .ant-modal-content .ant-modal-header .ant-modal-title {
  margin: 0 !important;
}
</style>